import { client } from 'src/enviroment/api/axios'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { Mutation, Query } from '../index'
import { RatingFramework, RatingFrameworkSearchParams } from '../../types/ratingFramework'
import { queryTool } from '../../enviroment/lib/utils'

export const ratingFrameworkRouterKeys = {
  ratingFrameworks: 'ratingFramework.ratingFrameworks',
} as const

export const ratingFrameworkRouter = {
  search: {
    useQuery: (params: RatingFrameworkSearchParams = {}, opts?: Query<RatingFramework[]>) => {
      const { query = '' } = params

      return useQuery<RatingFramework[]>({
        queryKey: [ratingFrameworkRouterKeys.ratingFrameworks, query],
        queryFn: async () => {
          return (
            await client.get<RatingFramework[]>('/rating-frameworks', {
              params: {
                query: queryTool(query),
              },
            })
          ).data
        },
        ...opts,
      })
    },
  },
  create: {
    useMutation: (opts?: Mutation<string, RatingFramework>) => {
      const queryClient = useQueryClient()

      return useMutation({
        mutationFn: async (name: string) => {
          return (await client.post<RatingFramework>('/rating-frameworks', { name })).data
        },
        onSuccess: (...args) => {
          queryClient.invalidateQueries({
            queryKey: [ratingFrameworkRouterKeys.ratingFrameworks],
          })
          opts?.onSuccess?.(...args)
        },
        ...opts,
      })
    },
  },
  delete: {
    useMutation: (opts?: Mutation<string, void>) => {
      const queryClient = useQueryClient()

      return useMutation({
        mutationFn: async (ratingFrameworkId: string) => {
          await client.delete(`/rating-frameworks/${ratingFrameworkId}`)
        },
        onSuccess: (...args) => {
          queryClient.invalidateQueries({
            queryKey: [ratingFrameworkRouterKeys.ratingFrameworks],
          })
          opts?.onSuccess?.(...args)
        },
        ...opts,
      })
    },
  },
}
